module.exports = __webpack_public_path__ + "static/digitale-ontwikkeling-haven-rotterdam-106869ef5ed15edd1efe03a4b408fa12.jpg";